import { render } from "./admin.vue?vue&type=template&id=429d8b02&ts=true"
import script from "./admin.vue?vue&type=script&lang=ts"
export * from "./admin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__